import Header from "./Header";
import Footer from "./Footer";
import Invest from "../components/tokenomics/Invest";
import tokenomicsShellStyle from "../styles/tokenomicsShellStyle";
import SeoHead from "../components/SeoHead";

const Ico = () => {
  return (
    <div className="tokenomics-shell" style={tokenomicsShellStyle}>
      <SeoHead
        title="Atheriam ICO - Invest in $ATH"
        description="Join the Atheriam ICO. $ATH powers the Agentic AI Layer 1 built for Web3 gaming. Announcement coming soon."
        path="/ico"
      />
      <Header />
      <main>
        <Invest />
      </main>
      <Footer />
    </div>
  );
};

export default Ico;
